module.exports = __webpack_public_path__ + "img/arrow-bottom-gray.435692d8.svg";